import Referral from "../models/Referral";

const ReferralStore = Referral.create();

export default ReferralStore;
